module.exports = __webpack_public_path__ + "static/media/rangearrow.7e40b6cd.svg";